document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initComparador();
  initCifras();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidad();
});

/* ---- Reveals al hacer scroll ------------------------------------------ */
function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var delay = el.getAttribute('data-mt-delay') || (i * 80);
        setTimeout(function () { el.classList.add('mt-visible'); }, delay);
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

/* ---- Comparador antes/después ------------------------------------------ */
function initComparador() {
  document.querySelectorAll('.mt-comparador').forEach(function (comp) {
    var antes = comp.querySelector('.mt-comparador__antes');
    var asa = comp.querySelector('.mt-comparador__asa');
    if (!antes || !asa) return;
    var dragging = false;

    function setPos(clientX) {
      var rect = comp.getBoundingClientRect();
      var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
      var pct = (x / rect.width) * 100;
      antes.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      asa.style.left = pct + '%';
    }

    comp.addEventListener('pointerdown', function (e) { dragging = true; setPos(e.clientX); });
    window.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
    window.addEventListener('pointerup', function () { dragging = false; });
    comp.addEventListener('touchstart', function (e) { if (e.touches[0]) setPos(e.touches[0].clientX); }, { passive: true });
    comp.addEventListener('touchmove', function (e) { if (e.touches[0]) setPos(e.touches[0].clientX); }, { passive: true });
  });
}

/* ---- Cifras animadas ---------------------------------------------------- */
function initCifras() {
  var els = document.querySelectorAll('[data-mt-count]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-mt-count')) || 0;
      var suffix = el.getAttribute('data-mt-suffix') || '';
      var start = 0;
      var duration = 1400;
      var startTime = null;
      function step(ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = start + (target - start) * eased;
        el.textContent = (Number.isInteger(target) ? Math.round(value) : value.toFixed(1)) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

/* ---- Galería de producto: miniaturas ------------------------------------ */
function initGaleriaProducto() {
  var principal = document.querySelector('[data-mt-imagen-principal]');
  var minis = document.querySelectorAll('[data-mt-miniatura]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-mt-miniatura');
      principal.src = src;
      minis.forEach(function (m) { m.classList.remove('mt-activa'); });
      mini.classList.add('mt-activa');
    });
  });
}

/* ---- Variantes de producto ---------------------------------------------- */
function initVariantesProducto() {
  var form = document.querySelector('#mt-form-producto');
  if (!form) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var pastillas = form.querySelectorAll('.mt-pastilla');
  var inputId = form.querySelector('input[name="id"]');
  var precioActual = document.querySelector('[data-mt-precio-actual]');
  var precioAnterior = document.querySelector('[data-mt-precio-anterior]');
  var botonComprar = form.querySelector('[data-mt-boton-comprar]');
  var avisoStock = document.querySelector('[data-mt-aviso-stock]');

  function opcionesSeleccionadas() {
    var seleccion = {};
    form.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
      var activa = grupo.querySelector('.mt-pastilla.mt-activa');
      if (activa) seleccion[grupo.getAttribute('data-mt-opcion')] = activa.getAttribute('data-mt-valor');
    });
    return seleccion;
  }

  function encontrarVariante() {
    var seleccion = opcionesSeleccionadas();
    return variantes.find(function (v) {
      return v.options.every(function (val, i) { return val === seleccion[v.optionNames[i]]; });
    });
  }

  function formatoDinero(centavos) {
    return (centavos / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR' });
  }

  function actualizar() {
    var variante = encontrarVariante();
    if (!variante) return;
    inputId.value = variante.id;
    if (precioActual) precioActual.textContent = formatoDinero(variante.price);
    if (precioAnterior) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAnterior.textContent = formatoDinero(variante.compare_at_price);
        precioAnterior.style.display = '';
      } else {
        precioAnterior.style.display = 'none';
      }
    }
    if (botonComprar) {
      if (variante.available) {
        botonComprar.removeAttribute('disabled');
        botonComprar.textContent = botonComprar.getAttribute('data-mt-texto-disponible');
      } else {
        botonComprar.setAttribute('disabled', 'disabled');
        botonComprar.textContent = botonComprar.getAttribute('data-mt-texto-agotado');
      }
    }
    if (avisoStock) {
      var umbral = parseInt(avisoStock.getAttribute('data-mt-umbral'), 10) || 0;
      var mostrar = variante.inventory_management === 'shopify' && variante.inventory_quantity > 0 && variante.inventory_quantity <= umbral;
      if (mostrar) {
        var plantilla = avisoStock.getAttribute('data-mt-plantilla-texto') || '';
        var textoEl = avisoStock.querySelector('[data-mt-aviso-stock-texto]');
        if (textoEl) textoEl.textContent = plantilla.replace('[cantidad]', variante.inventory_quantity);
        avisoStock.hidden = false;
      } else {
        avisoStock.hidden = true;
      }
    }
    if (variante.image) {
      var imagenPrincipal = document.querySelector('[data-mt-imagen-principal]');
      if (imagenPrincipal) imagenPrincipal.src = variante.image;
      var miniaturaCoincide = document.querySelector('[data-mt-miniatura="' + variante.image + '"]');
      if (miniaturaCoincide) {
        document.querySelectorAll('.mt-producto__miniatura').forEach(function (m) { m.classList.remove('mt-activa'); });
        miniaturaCoincide.classList.add('mt-activa');
      }
    }
  }

  pastillas.forEach(function (pastilla) {
    pastilla.addEventListener('click', function () {
      var grupo = pastilla.closest('[data-mt-opcion]');
      grupo.querySelectorAll('.mt-pastilla').forEach(function (p) { p.classList.remove('mt-activa'); });
      pastilla.classList.add('mt-activa');
      actualizar();
    });
  });

  actualizar();
}

/* ---- Selector de cantidad ------------------------------------------------ */
function initCantidad() {
  document.querySelectorAll('.mt-cantidad-caja').forEach(function (caja) {
    var input = caja.querySelector('input');
    var menos = caja.querySelector('[data-mt-menos]');
    var mas = caja.querySelector('[data-mt-mas]');
    if (!input) return;
    if (menos) menos.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (mas) mas.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
}
